import { render, staticRenderFns } from "./ModalNotice.vue?vue&type=template&id=3219649d&"
import script from "./ModalNotice.vue?vue&type=script&lang=js&"
export * from "./ModalNotice.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports